import { MS_PER_SECOND } from './time-units'

export const mapTimestampToDate = (timestamp?: number): Date | undefined => (
  timestamp ? new Date(timestamp * MS_PER_SECOND) : undefined
)
